import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';

const LENGTH = 6;

// 6-box OTP input, ported from Enjo's otp.jsx. Uppercases input, supports
// paste of a full 6-char code, and backspace-to-previous.
// A single ref holds the array of input instances (calling useRef in a loop
// would violate the rules of hooks).
const OtpInput = ({ value = '', onChange, error }) => {
  const inputs = useRef([]);

  const focusAt = (i) => {
    const el = inputs.current[i];
    if (el && el.focus) el.focus();
  };

  const handleChange = (index, raw) => {
    const ch = (raw || '').toUpperCase().slice(-1);
    const next = value.split('');
    next[index] = ch;
    onChange(next.join(''));
    if (ch && index < LENGTH - 1) focusAt(index + 1);
  };

  const handleKeyDown = (index, e) => {
    if (e.keyCode === 8 && !value[index] && index > 0) focusAt(index - 1);
  };

  const handlePaste = (e) => {
    const data = (e.clipboardData.getData('text') || '').trim();
    if (data.length !== LENGTH) return;
    onChange(data.toUpperCase());
    focusAt(LENGTH - 1);
    e.preventDefault();
  };

  useEffect(() => {
    focusAt(0);
  }, []);

  return (
    <div className="tpr-otp">
      {Array.from({ length: LENGTH }).map((_, i) => (
        <Input
          key={i}
          ref={(el) => {
            inputs.current[i] = el;
          }}
          className={`tpr-otp__box${error ? ' tpr-otp__box--error' : ''}`}
          maxLength={1}
          value={value[i] || ''}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OtpInput;
